// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

const S = {
  InterestCard: styled.div`
    display: flex;
    flex-direction: column;
    padding: 48px 80px;
    margin: 40px 0px;
    background: #FFFFFF;
    width: 846px;
    border-radius: 4px;
  `,
  InterestCardTitle: styled.div`
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    color: #434343;
  `,
  InterestCardSubtitle: styled.div`
    margin-top: 12px;
    font-size: 18px;
    line-height: 26px;
    color: #666666;
  `,
  ButtonOptionWrapper: styled.div`
    margin-top: 24px;
    display: grid;
    justify-content: center;
    width: 100%;
    grid-row-gap: 12px;
    grid-column-gap: 14px;
    grid-template-columns: repeat(3, 1fr);
  `,
  Button: styled.div<{ selected: boolean }>`
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    line-height: 26px;
    border-radius: 4px;
    cursor: pointer;

    ${({ selected }) => selected ? `
      background: #EF8200;
      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
      color: #FFFFFF;
    `: `
      background: #FFFFFF;
      border: 1px solid #C9C9C9;
      font-size: 18px;
      line-height: 26px;
      text-align: center;
      color: #EF8200;
    `}
  `,
};
export { S as default };
